import React from 'react'
import { Box } from '../../../vanilla'
import {SkeletonBlock} from '../../../components/skeleton-block'

export const DeliveryBoxSkeleton = () => {
    return (
        <>
            <Box
                flex="1"
                width="full"
                height="full"
                data-test-selector={`delivery-box-skeleton`}
                display="flex"
                flexDirection="column"
            >
                <Box display="flex" height="full" flexDirection="column" flex="1" gap="24px">
                    <Box display="flex" flexDirection={['row', 'column']} flexGrow={['1', '0']} gap="24px">
                        <SkeletonBlock height="56px" width="56px" flexShrink="0" />
                        <SkeletonBlock height={['56px', '24px']} flexGrow="1" />
                    </Box>
                    <SkeletonBlock display={['none', 'block']} height="100px" width="full" />
                    <Box display="flex" justifyContent="space-between" flexDirection={['row', 'column']} flexGrow={['0', '1']} >
                        <Box display="flex" flexDirection="column" gap="20px" flex="1">
                            <SkeletonBlock height="12px" width="half" />
                            <SkeletonBlock height="12px" width="half" />
                        </Box>
                        <SkeletonBlock height={['48px', '44px']} width={['48px', 'full']} />
                    </Box>
                </Box>
            </Box>
        </>
    )
}